<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{
  attach?: Element
}>()

const open = defineModel<boolean>({ required: true })

const emit = defineEmits<{
  confirm: []
  cancel: []
}>()

const { t } = useI18n()
</script>

<template>
  <v-dialog v-model="open" max-width="420" :attach="attach">
    <v-card>
      <v-card-title>{{ t('component.bopModelViewer.explodeOverrideTitle') }}</v-card-title>
      <v-card-text>{{ t('component.bopModelViewer.explodeOverrideMessage') }}</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="emit('cancel')">{{ t('button.cancel') }}</v-btn>
        <v-btn color="primary" variant="elevated" @click="emit('confirm')">
          {{ t('button.ok') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
